<template>
  <div class="column is-12">
    <div class="box">
      <div class="logtitle">
        <h3 class="title has-text-orange">Login</h3>
      </div>
      <form>
        <b-field label="Email">
          <b-input type="email" v-model="email"></b-input>
        </b-field>

        <b-field label="Password">
          <b-input type="password" v-model="password" password-reveal></b-input>
        </b-field>

        <p>{{authorizationError}}</p>

        <b-field>
          <p class="control">
            <button class="button is-primary" @click="authorize">
              Login
            </button>
          </p>
        </b-field>
      </form>
    </div>
  </div>
</template>


<script>
import UserService from '../services/UserService'

export default {
  name: 'LoginForm',
  data () {
    return {
      email: '',
      password: '',
      authorizationError: ''
    }
  },
  methods: {
    authorize (e) {
      e.preventDefault();
      UserService.login(this.email, this.password).then( (response) => {
        this.$store.dispatch('auth/login', response.data.token);
        this.$router.go('/');
      }).catch( (error) => {
        this.authorizationError = error.response.data.message;
      })
    }
  }
}
</script>
